import { render, staticRenderFns } from "./CountyCoordinatorView.vue?vue&type=template&id=152c22f1&scoped=true"
import script from "./CountyCoordinatorView.vue?vue&type=script&lang=js"
export * from "./CountyCoordinatorView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "152c22f1",
  null
  
)

export default component.exports